export const DO_SEARCH_REQUEST = 'DO_SEARCH_REQUEST';
export const DO_SEARCH_SUCCESS = 'DO_SEARCH_SUCCESS';
export const DO_SEARCH_FAILURE = 'DO_SEARCH_FAILURE';
